export const COMMON_CONSTS = {
  actions: {
    setCurrentInstance: 'setCurrentInstance',
    reset: 'reset',
  },
  mutations: {
    reset: 'reset',
  },
}
